import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import VisibilityIcon from "../../assets/view_eyeIcon.svg";
// import DownloadIcon from "../../assets/downloadIcon.svg"
import DeleteIcon from "../../assets/icon-trash.png"
import EditIcon from "../../assets/icon-pencil.png";
import HoverComponent from "./HoverComponent";
import SettingIcon from "../../assets/u_setting.svg"
import './TableComponent.css';

import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm'
import remarkBreaks from 'remark-breaks';


function TableComponent({
  columns,
  rows,
  setSelected,
  setOpenEditSettings,
  setOpenDeleteSettings,
  setOpenSettingsModal,
  canUpdate,
  canDelete,
  viewHistory,
  isProjectTabActive
}) {
  const navigate = useNavigate();
  const [expandedRows, setExpandedRows] = useState({});
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleRowClick = (rowIndex) => {
    setExpandedRows((prevState) => ({
      ...prevState,
      [rowIndex]: !prevState[rowIndex],  // Toggle the state for the clicked row
    }));
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleEdit = (event, row) => {
    setSelected(row);
    setOpenEditSettings(true);
  };

  const handleHistoryView = (event, row) => {
    navigate('/output-file', { state: { batch: row, mode: 'view' } });
  };

  const deleteSettings = (event, row) => {
    setSelected(row);
    setOpenDeleteSettings(true);
  };
  const handleSettings = (event, row) => {
    console.log(row, "row")
    setSelected(row);
    setOpenSettingsModal(true);
  };


  return (
    <>
      <TableContainer component={Paper} sx={{ borderRadius: '0' }}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead sx={{ backgroundColor: '#000000' }}>
            {columns &&
              <TableRow>
                {columns?.map((column, index) =>
                  <TableCell sx={{ color: '#ffffff' }} key={index} align={'left'}>{column.header}</TableCell>
                )}
              </TableRow>
            }
          </TableHead>
          <TableBody>
            {rows && rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
              <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} onClick={() => handleRowClick(index)} style={{ cursor: 'pointer' }}>
                {columns && columns?.map((column, subindex) => {
                  return (
                    <TableCell className={`tableCell-${subindex}`} key={subindex} align={'left'} style={{ verticalAlign: 'top' }}>
                      {
                        column.field === 'action' ? (
                          viewHistory && viewHistory ? (<>
                            {/* {canUpdate && */}
                            <IconButton
                              aria-label="view"
                              onClick={(e) => handleHistoryView(e, row)}
                              sx={{ p: 0, pr: '0.5rem' }}
                            >
                              <img src={VisibilityIcon} alt="ViewIcon" />
                            </IconButton>
                            {/* } */}
                          </>) : (
                            <>
                              {canUpdate &&
                                <IconButton
                                  aria-label="edit"
                                  onClick={(e) => handleEdit(e, row)}
                                  sx={{ p: 0, pr: '0.5rem' }}
                                >
                                  <img src={EditIcon} alt="EditIcon" />
                                </IconButton>
                              }
                              {canDelete &&
                                <IconButton
                                  aria-label="delete"
                                  onClick={(e) => deleteSettings(e, row)}
                                  sx={{ p: 0, pr: '0.5rem' }}
                                >
                                  <img src={DeleteIcon} alt="DeleteIcon" />
                                </IconButton>
                              }
                              {column.field === "action" && isProjectTabActive && (
                                <IconButton
                                  aria-label="settings"
                                  onClick={(e) => handleSettings(e, row)}
                                  sx={{ p: 0, pr: '0.5rem' }}
                                >
                                  <img src={SettingIcon} alt="SettingIcon" />
                                </IconButton>
                              )}
                            </>)

                        ) : (column.header === 'No. Of Projects' || column.header === 'No. Of Organisations') ?
                          (<div style={{ display: 'flex', alignItems: 'center' }}>
                            {row[column.field]}
                            {/* <div className="informationIcon">i
                          <HoverComponent />
                        </div> */}
                          </div>
                          ) :
                          (
                            row[column.field]?.length >= 70 ?
                              <div
                                style={{
                                  width: '420px',
                                  maxHeight: expandedRows[index] ? 'fit-content' : '28px',
                                  whiteSpace: expandedRows[index] ? 'normal' : 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                }}
                              >
                                <ReactMarkdown children={row[column.field]?.toString()} remarkPlugins={[remarkGfm, remarkBreaks]} />
                              </div> :
                              <ReactMarkdown children={row[column.field]?.toString()} remarkPlugins={[remarkGfm, remarkBreaks]} />
                          )

                      }
                    </TableCell>)
                })}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {rows && columns &&
        <TablePagination
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          sx={{
            '& .MuiTablePagination-selectLabel': {
              display: 'none',
              marginBottom: '0px'
            },
            '& .MuiTablePagination-displayedRows': {
              marginBottom: '0px'
            },
            '& .MuiTablePagination-toolbar': {
              justifyContent: 'flex-end',
            },
            '& .MuiTablePagination-spacer': {
              flex: 'none',
              display: 'none'
            },
            '& .MuiTablePagination-actions': {
              marginLeft: 0,
            },
            '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
              marginRight: 2,
            },
            '& .MuiInputBase-root': {
              display: 'none',
            },
          }}
        />
      }
    </>
  );
}

export default TableComponent;